export const sumTotal = (arr) => arr.reduce((sum, { qty }) => (qty >= 0 ? sum + qty : sum), 0);
